// import { SpinnerService } from '@/app/shared';
// import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { CookieService } from 'ngx-cookie-service';
// import { catchError, finalize, switchMap, throwError } from 'rxjs';
// import { TOKEN } from '../keys/key';
// import { AuthService } from '../services/auth.service';
// import { MessageService } from 'primeng/api';

// export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
//   const messageService = inject(MessageService);

//   const excludedUrls = ['/login', '/error-log'];

//   const publicUrls = [
//     { url: '/usuarios', method: 'GET' },
//     { url: '/certificado', method: 'GET' },
//   ];

//   //? Verificar si la URL de la solicitud está en la lista de exclusión
//   const shouldExclude = excludedUrls.some((url) => req.url.includes(url));

//   const isPublic = publicUrls.some(
//     (u) => req.url.includes(u.url) && req.method == u.method,
//   );

//   const spinner = inject(SpinnerService);

//   if (!shouldExclude) spinner.toggleLoading(true);

//   //? Si el usuario está en el login, pasa la request sin modificar
//   if (shouldExclude)
//     return next(req).pipe(finalize(() => spinner.toggleLoading(false)));
//   //? Inyección de dependencias
//   const cookie = inject(CookieService);
//   const auth = inject(AuthService);
//   //* Obtenemos el token de las cookies
//   const token = cookie.get(TOKEN);
//   //! Si no hay token, restringimos el acceso

//   if (!token) {
//     if (isPublic)
//       return next(req).pipe(finalize(() => spinner.toggleLoading(false)));

//     spinner.toggleLoading(false);
//     return restrict(auth, 'No se proveyó el TOKEN', true);
//   }

//   //* Clonamos la solicitud para agregar el encabezado de autorización
//   const request = req.clone({
//     setHeaders: {
//       authorization: `Bearer ${token}`,
//     },
//   });

//   return next(request).pipe(
//     catchError((err: HttpErrorResponse) => {
//       const isRefreshRequest = req.url.includes('/auth/refreshToken');
//       // if ([400].includes(err.status)) return throwError(() => err);

//       if ([401, 403].includes(err.status)) {
//         if (err.status === 401 && !isRefreshRequest) {
//           // 👇 Mostrar popup
//           messageService.add({
//             severity: 'warn',
//             summary: 'Sesión finalizada',
//             detail:
//               'Tu sesión fue cerrada porque iniciaste sesión en otro dispositivo',
//             life: 7000,
//           });
//         }

//         auth.logout().subscribe();
//         return throwError(() => err);
//       }

//       return auth.refreshToken().pipe(
//         switchMap((newToken) => {
//           const retryRequest = req.clone({
//             setHeaders: {
//               authorization: `Bearer ${newToken}`,
//             },
//           });

//           return next(retryRequest);
//         }),
//         catchError((refreshError) => {
//           auth.forceLogout();
//           return throwError(() => refreshError);
//         }),
//       );
//     }),
//     finalize(() => spinner.toggleLoading(false)),
//   );
// };

// /**
//  * @description
//  * Realiza el logout, lanza un error con un mensaje personalizado y detiene el flujo.
//  */
// const restrict = (auth: AuthService, msg: any, logout: boolean) => {
//   if (logout) auth.logout();
//   return throwError(() => msg);
// };

import { SpinnerService } from '@/app/shared';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { catchError, finalize, switchMap, throwError } from 'rxjs';

import { TOKEN } from '../keys/key';
import { AuthService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const spinner = inject(SpinnerService);
  const cookie = inject(CookieService);
  const auth = inject(AuthService);

  const excludedUrls = ['/login', '/error-log', '/auth/refreshToken'];

  const publicUrls = [
    { url: '/usuarios', method: 'GET' },
    { url: '/certificado', method: 'GET' },
  ];

  const shouldExclude = excludedUrls.some((url) => req.url.includes(url));

  const isPublic = publicUrls.some(
    (item) => req.url.includes(item.url) && req.method === item.method,
  );

  if (shouldExclude) {
    return next(req);
  }

  spinner.toggleLoading(true);

  const token = cookie.get(TOKEN);

  if (!token) {
    if (isPublic) {
      return next(req).pipe(finalize(() => spinner.toggleLoading(false)));
    }

    spinner.toggleLoading(false);
    auth.forceLogout();

    return throwError(() => new Error('No se proporcionó el access token'));
  }

  const request = req.clone({
    setHeaders: {
      authorization: `Bearer ${token}`,
    },
  });

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status !== 401) return throwError(() => err);

      // No renovar recursivamente el endpoint de refresh.
      if (req.url.includes('/auth/refreshToken')) {
        auth.forceLogout();
        return throwError(() => err);
      }

      // Si el backend informa explícitamente que la sesión fue revocada.
      const code = err.error?.code;

      if (code === 'SESSION_REVOKED') {
        messageService.add({
          severity: 'warn',
          summary: 'Sesión finalizada',
          detail:
            'Tu sesión fue cerrada porque iniciaste sesión en otro dispositivo',
          life: 7000,
        });

        auth.forceLogout();
        return throwError(() => err);
      }

      return auth.refreshToken().pipe(
        switchMap((newToken) => {
          const retryRequest = req.clone({
            setHeaders: {
              authorization: `Bearer ${newToken}`,
            },
          });

          return next(retryRequest);
        }),
        catchError((refreshError) => {
          auth.forceLogout();
          return throwError(() => refreshError);
        }),
      );
    }),
    finalize(() => spinner.toggleLoading(false)),
  );
};
